import { read, readFile } from 'xlsx';
/**
 * The DATParser is responsible for implementing an algorithm for parsing the
 * CSV representation of the FormSpec. The CSV representation of the FormSpec is obtained
 * from converting the XLSX file provided to a CSV, with each table converted
 * to its own file, and choosing the 'Form FormSpec-Table 1.csv'.
 *
 * @export
 * @class DATParser
 */
export class DATParser {
    // async fromFiles(infoFile: string, datFile: string): Promise<FormSpec> {
    // }
    async parseText(fileText) {
        // const fields = [
        // 	'fieldNumber',
        // 	'fieldLabel',
        // 	'fieldId',
        // 	'required',
        // 	'minimumOccurences',
        // 	'maximumOccurences',
        // 	'agencyFieldName',
        // 	'fieldType',
        // 	'globalLibraryFieldName',
        // 	'fieldTypeSource',
        // 	'businessRules',
        // 	'dataType',
        // 	'listOfValues',
        // 	'minCharsOrMinValue',
        // 	'maxCharsOrMaxValue',
        // 	'fieldImplementation',
        // 	'helpTip',
        // 	'mandatoryMessage',
        // 	'validationMessage',
        // ]
        const dat = {
            formTitle: '',
            formId: '',
            formVersion: '',
            ombControlNumber: '',
            ombExpirationDate: '',
            formFamilies: [],
            fields: [],
        };
        // @ts-ignore
        const csvData = await parse.parse(fileText, { delimeter: ',' });
        // Skip the first 6 entries because they aren't fields
        // @ts-ignore
        for (let i = 6; i < csvData.length; i++) {
            // @ts-ignore
            const fieldData = csvData[i];
            // Modify the field label field, by removing the "* " before a label
            // if it exists, because im not sure why this in the dat, but it
            // stops us from doing direct comparisons between the label in the
            // dat and the label in the webform, because none of the webform
            // labels include the "* "
            // They add a "* " before a field label for required fields
            if (fieldData[1].includes('* ')) {
                fieldData[1] = fieldData[1].substring(2, fieldData[1].length);
            }
            // If any of the field's properties are the empty string, set that
            // property to null
            for (let i = 0; i < fieldData.length; i++) {
                fieldData[i] = fieldData[i].replace(/^\s+|\s+$/g, ''); // remove string at beg / end
                fieldData[i] = fieldData[i].replace(/\n/g, ' '); // remove newlines
                fieldData[i] = fieldData[i].replace(/\s+/g, ' '); // remove multiple string in between words
                if (fieldData[i] === '')
                    fieldData[i] = null;
            }
            dat.fields.push({
                fieldNumber: fieldData[0],
                fieldLabel: fieldData[1],
                fieldId: fieldData[2],
                required: fieldData[3],
                minimumOccurences: Number.parseInt(fieldData[4]),
                maximumOccurences: Number.parseInt(fieldData[5]),
                agencyFieldName: fieldData[6],
                fieldType: fieldData[7],
                globalLibraryFieldName: fieldData[8],
                fieldTypeSource: fieldData[9],
                businessRules: fieldData[10],
                dataType: fieldData[11],
                listOfValues: fieldData[12],
                minCharsOrMinValue: fieldData[13],
                maxCharsOrMaxValue: fieldData[14],
                fieldImplementation: fieldData[15],
                helpTip: fieldData[16],
                mandatoryMessage: fieldData[17],
                validationMessage: fieldData[18],
            });
        }
        return dat;
    }
    async parseInfoFromInfoCSV(fileText) {
        // Split file
        const data = fileText.split('\n');
        const csvData = data.map(line => line.split(','));
        // Build initial empty FormSpec
        const dat = {
            formTitle: '',
            formId: '',
            formVersion: '',
            ombControlNumber: '',
            ombExpirationDate: '',
            formFamilies: [],
            fields: [],
        };
        // Parse Form Attributes
        dat.formTitle = csvData[1][1];
        dat.formId = csvData[2][1];
        dat.formVersion = csvData[3][1];
        dat.ombControlNumber = csvData[4][1];
        dat.ombExpirationDate = csvData[5][1];
        // Parse Form Families
        if (csvData[6][1] === 'X')
            dat.formFamilies.push(csvData[6][2]);
        if (csvData[7][1] === 'X')
            dat.formFamilies.push(csvData[7][2]);
        if (csvData[8][1] === 'X')
            dat.formFamilies.push(csvData[8][2]);
        if (csvData[9][1] === 'X')
            dat.formFamilies.push(csvData[9][2]);
        if (csvData[10][1] === 'X')
            dat.formFamilies.push(csvData[10][2]);
        // Return populated FormSpec
        return dat;
    }
    async parseFieldsFromDATCSV(fileText) {
        // Split file
        const data = fileText.split('\r\n');
        const csvData = data.map(line => line.split(','));
        const parsedFields = [];
        // Skip the first 6 entries because they aren't fields
        for (let i = 38; i < csvData.length; i++) {
            // @ts-ignore
            const fieldData = csvData[i];
            // Modify the field label field, by removing the "* " before a label
            // if it exists, because im not sure why this in the dat, but it
            // stops us from doing direct comparisons between the label in the
            // dat and the label in the webform, because none of the webform
            // labels include the "* "
            // They add a "* " before a field label for required fields
            let asteriskIndex = -1;
            asteriskIndex = fieldData[1].indexOf('* ');
            if (asteriskIndex !== -1) {
                fieldData[1] =
                    fieldData[1].substring(0, asteriskIndex) +
                        fieldData[1].slice(asteriskIndex + 2, fieldData[1].length);
            }
            asteriskIndex = fieldData[1].indexOf(' * ');
            if (asteriskIndex !== -1) {
                fieldData[1] =
                    fieldData[1].substring(0, asteriskIndex) +
                        fieldData[1].slice(asteriskIndex + 3, fieldData[1].length);
            }
            // If any of the field's properties are the empty string, set that
            // property to null
            for (let i = 0; i < fieldData.length; i++) {
                fieldData[i] = fieldData[i].replace(/^\s+|\s+$/g, ''); // remove string at beg / end
                fieldData[i] = fieldData[i].replace(/\n/g, ' '); // remove newlines
                fieldData[i] = fieldData[i].replace(/\s+/g, ' '); // remove multiple string in between words
                if (fieldData[i] === '')
                    fieldData[i] = null;
            }
            parsedFields.push({
                fieldNumber: fieldData[0],
                fieldLabel: fieldData[1],
                fieldId: fieldData[2],
                // @ts-ignore
                required: fieldData[3],
                minimumOccurences: Number.parseInt(fieldData[4]),
                maximumOccurences: Number.parseInt(fieldData[5]),
                agencyFieldName: fieldData[6],
                fieldType: fieldData[7],
                globalLibraryFieldName: fieldData[8],
                fieldTypeSource: fieldData[9],
                businessRules: fieldData[10],
                dataType: fieldData[11],
                listOfValues: fieldData[12],
                minCharsOrMinValue: fieldData[13],
                maxCharsOrMaxValue: fieldData[14],
                fieldImplementation: fieldData[15],
                helpTip: fieldData[16],
                mandatoryMessage: fieldData[17],
                validationMessage: fieldData[18],
            });
        }
        return parsedFields;
    }
    fromXlsx(filePath) {
        const workbook = readFile(filePath);
        return this.parseFromXlsx(workbook);
    }
    fromXlsxFile(file) {
        const workbook = read(file);
        return this.parseFromXlsx(workbook);
    }
    parseFromXlsx(workbook) {
        const dat = this.parseFormInfoFromSheet(workbook.Sheets['Form Info']);
        dat.fields = this.parseFieldsFromSheet(workbook.Sheets['Form FormSpec'] ?? workbook.Sheets['Form DAT']);
        return dat;
    }
    parseFormInfoFromSheet(sheet) {
        // Parse all of the fields from the "Form Info"
        // sheet that we need to create the FormSpec,
        // for now we are not getting the rest of
        // the fields, but I will add this and
        // run it again later with that
        const info = sheet;
        function getCellValue(num) {
            if (info[num] == null)
                return '';
            return info[num].w;
        }
        const formTitle = getCellValue('B2');
        const formId = getCellValue('B3');
        const formVersion = getCellValue('B4');
        const ombControlNumber = getCellValue('B5');
        const ombExpirationDate = getCellValue('B6');
        const formFamilies = [];
        for (let i = 7; i < 12; i++) {
            if (info[`B${i}`])
                formFamilies.push(getCellValue(`C${i}`));
        }
        // Create the FormSpec for the form from the Form Info,
        // post the FormSpec to the repository as a requirements
        // document, then continue to make the component
        // and relationships for the webform
        return {
            formTitle,
            formId: `${formId}`,
            formVersion,
            ombControlNumber,
            ombExpirationDate,
            formFamilies,
            fields: [],
        };
    }
    parseFieldsFromSheet(sheet) {
        const parsedFields = [];
        const rows = Object.keys(sheet).filter(key => {
            return key.charAt(0) === 'A';
        });
        for (let i = 3; i < rows.length; i++) {
            const num = rows[i].substring(1, rows[i].length);
            parsedFields.push({
                fieldNumber: cleanLabel(sheet['A' + num]),
                fieldLabel: cleanField(sheet['B' + num]),
                fieldId: cleanField(sheet['C' + num]),
                // @ts-ignore
                required: cleanField(sheet['D' + num]),
                minimumOccurences: tryParseInt(cleanField(sheet['E' + num])),
                maximumOccurences: tryParseInt(cleanField(sheet['F' + num])),
                agencyFieldName: cleanField(sheet['G' + num]),
                fieldType: cleanField(sheet['H' + num]),
                globalLibraryFieldName: cleanField(sheet['I' + num]),
                fieldTypeSource: cleanField(sheet['J' + num]),
                businessRules: cleanField(sheet['K' + num]),
                dataType: cleanField(sheet['L' + num]),
                listOfValues: cleanField(sheet['M' + num]),
                minCharsOrMinValue: cleanField(sheet['N' + num]),
                maxCharsOrMaxValue: cleanField(sheet['O' + num]),
                fieldImplementation: cleanField(sheet['P' + num]),
                helpTip: cleanField(sheet['Q' + num]),
                mandatoryMessage: cleanField(sheet['R' + num]),
                validationMessage: cleanField(sheet['S' + num]),
            });
        }
        return parsedFields;
        // Modify the field label field, by removing the "* " before a label
        // if it exists, because im not sure why this in the dat, but it
        // stops us from doing direct comparisons between the label in the
        // dat and the label in the webform, because none of the webform
        // labels include the "* "
        // They add a "* " before a field label for required fields
        function cleanLabel(cell) {
            if (cell == null)
                return null;
            let label = cell.w;
            if (label == null)
                return null;
            let asteriskIndex = -1;
            asteriskIndex = label.indexOf('* ');
            if (asteriskIndex !== -1) {
                label =
                    label.substring(0, asteriskIndex) +
                        label.slice(asteriskIndex + 2, label.length);
            }
            asteriskIndex = label.indexOf(' * ');
            if (asteriskIndex !== -1) {
                label =
                    label.substring(0, asteriskIndex) +
                        label.slice(asteriskIndex + 3, label.length);
            }
            label = label.replace(/^\s+|\s+$/g, ''); // remove string at beg / end
            label = label.replace(/\n/g, ' '); // remove newlines
            label = label.replace(/\s+/g, ' '); // remove multiple string in between words
            if (label === '')
                return null;
            return label;
        }
        function cleanField(cell) {
            if (cell == null)
                return null;
            let field = cell.w;
            if (field == null)
                return null;
            field = field.replace(/^\s+|\s+$/g, ''); // remove string at beg / end
            field = field.replace(/\n/g, ' '); // remove newlines
            field = field.replace(/\s+/g, ' '); // remove multiple string in between words
            if (field === '')
                return null;
            return field;
        }
    }
}
const tryParseInt = (intLike) => {
    if (intLike == null)
        return undefined;
    const parsed = parseInt(intLike);
    return isNaN(parsed) ? undefined : parsed;
};
//# sourceMappingURL=dat-parser.js.map